// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {PageBackground} from './page-background.js'

export class SetPageBackground {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetPageBackground {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetPageBackground(bb: flatbuffers.ByteBuffer, obj?: SetPageBackground): SetPageBackground {
    return (obj || new SetPageBackground()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetPageBackground(
    bb: flatbuffers.ByteBuffer,
    obj?: SetPageBackground
  ): SetPageBackground {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetPageBackground()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(obj?: PageBackground): PageBackground | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new PageBackground()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startSetPageBackground(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0)
  }

  static endSetPageBackground(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetPageBackground(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetPageBackground.startSetPageBackground(builder)
    SetPageBackground.addValue(builder, valueOffset)
    return SetPageBackground.endSetPageBackground(builder)
  }
}
